export const UserReducer = (state = {user:[]}, action) =>{
    switch (action.type) {
        case "UserRequest":
            return{
                loading:true,
            }
        case "UserSuccess":
            return{
                loading:false,
                user:action.payload
            }
        case "UserFail": 
            return{
                loading:true,
                user:"No data Found"
            }
        default:
            return {
                loading : true,
                ...state
            };
    }
}
